import styled from 'styled-components';
import { Drawer } from '@mui/material';

import colors from '../../../../styles/colors';

const DRAWER_WIDTH = 380;

const StyledDrawer = styled(Drawer)`
  .MuiDrawer-paper {
    width: ${DRAWER_WIDTH}px;
    display: flex;
    flex-direction: column;
  }
`;

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

/**
 * $centered: when true (loading or empty state), content is centered.
 * When false (list), content is top-aligned with no centering.
 */
const DrawerBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  ${({ $centered }) => $centered && `
    align-items: center;
    justify-content: center;
  `}
`;

const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const ItemCard = styled.div`
  border: 1px solid ${colors.shades.gamma3};
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.15s ease, opacity 0.3s ease;

  &:hover {
    background-color: ${colors.shades.gamma12};
  }
`;

const CardRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

/**
 * $visible: controls visibility (not display) so layout is stable
 * regardless of read status.
 */
const UnreadDot = styled.span`
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${colors.shades.secondary2};
  margin-top: 6px;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;

const CardContent = styled.div`
  flex: 1;
  min-width: 0;
`;

const CardTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.base.beta};
  margin-bottom: 10px;
`;

const CardMessage = styled.div`
  font-size: 12px;
  color: ${colors.shades.beta1};
  /* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */
  overflow: hidden;
  margin: 4px 0;
`;

const CardTimestamp = styled.span`
  font-size: 11px;
  color: ${colors.shades.gamma2};
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
`;

export {
  StyledDrawer,
  DrawerHeader,
  DrawerBody,
  ItemList,
  ItemCard,
  CardRow,
  UnreadDot,
  CardContent,
  CardTitle,
  CardMessage,
  CardTimestamp,
  CardFooter,
};
